import styled from 'styled-components'

export const Container = styled.div`
  min-width: 300px;
  background: #fff;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  padding: 30px 30px 23px 30px;
  gap: 20px;
`
export const SelectsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
`

export const ButtonsContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: right;
  gap: 10px;
`

export const Button = styled.button`
  color: ${props => (props.type === 'submit' ? '#fff' : '#000')};

  background: ${props =>
    props.type === 'submit' ? 'var(--hover)' : 'var(--grey26)'};
  padding: 7px 14px;
  border-radius: 5px;
`

export const SelectContainer = styled.div`
  display: flex;
  flex-direction: column;
  font-size: 14px;
  border: 1px solid var(--grey26);
  border-radius: 8px;
  padding: 1rem;
  gap: 16px;
`

export const SelectButton = styled.button`
  width: 100%;
  height: 18px;
  background: transparent;
  color: var(--grey15);
  display: flex;
  align-items: center;
  justify-content: space-between;
`
export const SelectItemsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`

export const SelectItem = styled.div`
  height: 34px;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
  cursor: pointer;
`

interface RadioDotProps {
  isSelected: boolean
}

export const RadioDot = styled.div<RadioDotProps>`
  width: 16px;
  height: 16px;
  border-radius: 50%;
  border: 4px solid var(--grey26);
  background-color: ${props =>
    props.isSelected ? 'var(--blue)' : 'var(--grey26)'};
  position: relative;

  &::after {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 4px;
    height: 4px;
    border-radius: 50%;
    opacity: ${props => (props.isSelected ? 1 : 0)};
  }
`
